import classnames from 'classnames';

import {SITE_URLS} from 'features/search/constants';
import {useDeviceStore, selectIsMobile} from 'features/ui/store/useDeviceStore';
import * as React from 'react';
import {IContentBlock} from 'features/blocks/types';

import './style.scss';
import {VideoBlock} from "components/blocks/ImageAndVideo/VideoBlock";

import {AccessibleSlider} from '@molecules/SlidingContent/AccessibleSlider';
import {ImageLinkBlockItem} from "components/blocks/Link/ImageLinkBlockItem";

export enum ContentSliderThemes {
    DEFAULT = 'Default',
    PREMIUM = 'Premium',
    SMARTA_KVADRAT = 'Smarta Kvadrat',
}

export interface ContentSliderBlockType {
    theme: string;
    title: string;
    mainText: string;
    buttonText: string;
    buttonLink: string;
    sliderItems: IContentBlock<any>[]; // eslint-disable-line @typescript-eslint/no-explicit-any -- polymorphic block dispatch
    useNarrowWidthBlocks: boolean;
}
type Props = IContentBlock<ContentSliderBlockType>;

export const ContentSliderBlock: React.FunctionComponent<Props> = ({id, data}) => {

    const _isMobile = useDeviceStore(selectIsMobile);

    const showSlider = () => {
        if (!data.sliderItems) return false;
        if (data.sliderItems.length > 1) return true;
        if (data.sliderItems.length == 1 && data.mainText && data.mainText != '') return true;
        return false;
    };
    const showSingle = () => {
        if (!data.sliderItems) return false;
        if (data.sliderItems.length === 1 && (!data.mainText || data.mainText == '')) return true;
        return false;
    };
    const getButtonLink = () => {
        if(data.theme === ContentSliderThemes.PREMIUM) return SITE_URLS.searchUrl + '?concepts=5dc37423-5ca6-4ce5-96af-4231b44a789c';
        if(data.theme === ContentSliderThemes.SMARTA_KVADRAT) return SITE_URLS.searchUrl + '?concepts=92931782-fc1c-469d-a05b-dedcc4c7b6c6';

        return data.buttonLink;
    };

    const containerClasses = classnames('content-slider-block', {
        'content-slider-block--premium premium': data.theme === ContentSliderThemes.PREMIUM,
        'content-slider-block--smarta-kvadrat': data.theme === ContentSliderThemes.SMARTA_KVADRAT,
    });
    const sliderClasses = classnames('content-slider-block__slider', {
        'content-slider-block__slider--single' : data.sliderItems.length === 1,
    });

    return (
        <div className={containerClasses} id={id}>
            {showSlider() &&
                <AccessibleSlider
                    className={sliderClasses}

                    wide={!data.useNarrowWidthBlocks} 
                    dark={data.theme === ContentSliderThemes.PREMIUM}

                    header={data.title}
                    textHtml={data.mainText}
                    link={getButtonLink()}
                    linkText={data.buttonText}
                >
                    {data.sliderItems.map((item, key) => (
                        <React.Fragment key={`fragment-block-${key}`}>
                            {item.component === 'video-block' &&
                                <VideoBlock key={`content-block-${key}`} {...item} />
                            }
                            {item.component === 'image-link-block-item' &&
                                <ImageLinkBlockItem
                                    key={`content-block-${key}`}
                                    {...item}
                                    bigImageSize
                                    smallSliderCard={data.useNarrowWidthBlocks}
                                    sliderItem
                                />
                            }
                        </React.Fragment>
                    ))}
                </AccessibleSlider>
            }
            {showSingle() &&
                <React.Fragment>
                    {data.sliderItems[0].component === 'video-block' &&
                        <VideoBlock {...data.sliderItems[0]} />
                    }
                    {data.sliderItems[0].component === 'image-link-block-item' &&
                        <ImageLinkBlockItem {...data.sliderItems[0]} bigImageSize />
                    }
                </React.Fragment>
            }
        </div>
    )
};

